// extracted by mini-css-extract-plugin
export default {"infoContainer":"ProfileViewInfo_infoContainer__hARUG"};